import {useState} from "react";
import history from "../../utils/History";

function LogoutOrNotAuthorized(props) {

    const flagDatiMancanti = useState(history && history.state && history.state.flagDatiMancanti ? history.state.flagDatiMancanti : false)

    if (flagDatiMancanti) {
        return (
            <div>
                <div className={"container"} style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
                    <p style={{fontSize: "20px", textAlign: "center"}}>
                        <strong>Siamo spiacenti, i dati utente sono incompleti.</strong>
                        <br/>
                        <a href={"/logout"}>Clicca qui per eseguire il logout</a>
                    </p>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <div className={"container"} style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
                    <p style={{fontSize: "20px", textAlign: "center"}}>
                        <strong>Siamo spiacenti, non è stata concessa l'autorizzazione per visualizzare questa
                            pagina.</strong>
                        <br/>
                        <a href={"/home"}>Clicca qui per ritornare alla Home</a>
                    </p>
                </div>
            </div>
        );
    }
}
export default LogoutOrNotAuthorized